import React from "react";
import logo from "../../../Assets/logo/whiteLogo.png";
import { useNavigate } from "react-router-dom";
import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Courses", path: "/courses" },
    { name: "Articles", path: "/articles" },
    { name: "Career", path: "/careers" },
    { name: "Contact", path: "/contact" },
  ];

  const courses = [
    { name: "Web Development- MERN Stack", path: "/courses/web-development" },
    { name: "Data Science", path: "/courses/data-science" },
    { name: "Machine Learning", path: "/courses/machine-learning" },
    {
      name: "AI/ML",
      path: "/courses/ai-ml",
    },
    { name: "Generative AI", path: "/courses/generative-ai" },
  ];

  return (
    <React.Fragment>
      <footer className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-slate-100 pt-10 pb-6 px-4">
        <div className="mx-auto max-w-7xl">
          {/* TOP GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <img src={logo} alt="WBC logo" className="mb-4 h-14 w-auto" />
              <p className="mt-2 text-sm text-slate-300 leading-relaxed">
                WBC facilitates real-time, bidirectional learning and mentorship
                between students and industry experts.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xs font-semibold tracking-[0.2em] text-slate-400">
                QUICK LINKS
              </h3>
              <ul className="mt-4 space-y-2 text-sm">
                {quickLinks.map((link, index) => (
                  <li
                    key={index}
                    onClick={() => handleNavigate(link.path)}
                    className="cursor-pointer text-slate-200 hover:text-[#64a2ff] transition-colors"
                  >
                    {link.name}
                  </li>
                ))}
              </ul>
            </div>

            {/* Courses */}
            <div>
              <h3 className="text-xs font-semibold tracking-[0.2em] text-slate-400">
                COURSES
              </h3>
              <ul className="mt-4 space-y-2 text-sm">
                {courses.map((course, index) => (
                  <li
                    key={index}
                    onClick={() => handleNavigate(course.path)}
                    className="cursor-pointer text-slate-200 hover:text-[#64a2ff] transition-colors"
                  >
                    {course.name}
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-xs font-semibold tracking-[0.2em] text-slate-400 uppercase">
                Contact Us
              </h3>

              <div className="space-y-3 text-sm text-slate-200 mt-3">
                <div className="flex items-start gap-3">
                  <span className="mt-1 flex h-8 w-8 items-center justify-center rounded-full bg-[#064585]/10">
                    <FiMapPin size={18} />
                  </span>
                  <span className="leading-relaxed">
                    UCO Bank Top Floor, Kolathia, Khandagiri, Bhubaneswar,
                    751030
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#064585]/10">
                    <FiMail size={18} />
                  </span>
                  <a
                    href="mailto:classeswebbocket@gmail.com"
                    className="hover:text-[#64a2ff]"
                  >
                    classeswebbocket@gmail.com
                  </a>
                </div>

                <div className="flex items-center gap-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#064585]/10">
                    <FiPhone size={18} />
                  </span>
                  <a href="tel:9861934932" className="hover:text-[#64a2ff]">
                    +91 9861934932
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#064585]/10">
                    <FiPhone size={18} />
                  </span>
                  <a href="tel:7656081495" className="hover:text-[#64a2ff]">
                    +91 76560 81495
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* BOTTOM STRIP */}
          <div className="mt-8 border-t border-white/30 pt-4 flex flex-col md:flex-row items-center justify-between gap-3 text-xs sm:text-sm text-slate-400">
            <p>© {currentYear} WBC. All rights reserved.</p>
            <div className="flex gap-4">
              <span
                className="cursor-pointer hover:text-[#64a2ff] transition-colors"
                onClick={() => handleNavigate("/tc")}
              >
                Terms &amp; Conditions
              </span>

              <span
                className="cursor-pointer hover:text-[#64a2ff] transition-colors"
                onClick={() => handleNavigate("/privacy")}
              >
                Privacy Policy
              </span>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
